module.exports = __webpack_public_path__ + "img/inlinelogo.01d102d2.png";